import axios from "axios";
import { getRolesByCountry } from "./GetRolesByCountryAction";
import {
  updateRoleRequested,
  updateRoleRequestSucceeded,
  updateRoleRequestFailed,
} from "../slices/UpdateRoleSlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Rol`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const getSelectedCountryId = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData || !selectedCountry) {
    return null;
  }

  const session = JSON.parse(sessionData);
  const country = (session.rols || [])
    .map((entry) => entry.country)
    .find((item) => item?.countryName === selectedCountry);

  return country?.idcountry ?? null;
};

export const UpdateRole = (role) => async (dispatch) => {
  try {
    dispatch(updateRoleRequested());

    const putData = {
      idrole: Number(role.idrole),
      roleName: role.roleName,
      isActive: role.isActive,
      addToAll: role.addToAll,
      countryId: Number(role.countryId ?? getSelectedCountryId()),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(apiUrl, putData, axiosConfig);

    if (response.data === true) {
      dispatch(updateRoleRequestSucceeded(response.data));
      await dispatch(getRolesByCountry());
      return { success: true, message: "Role updated successfully" };
    }

    const errorMessage =
      "The role could not be updated. A role with the same name may already exist.";
    dispatch(updateRoleRequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(updateRoleRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
